import { render, staticRenderFns } from "./assetsReport.vue?vue&type=template&id=5b304bae"
import script from "./assetsReport.vue?vue&type=script&lang=js"
export * from "./assetsReport.vue?vue&type=script&lang=js"
import style0 from "./assetsReport.vue?vue&type=style&index=0&id=5b304bae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports